export const getUser = (state) => state.account.userSession.data
